/* Alambique · Homepage CRO v3 (sections/alp-home-redesign.liquid).
   Se carga con async solo en el index (snippets/alp-home-chrome). Idempotente: si el archivo se evalúa
   dos veces no duplica listeners; en el editor, shopify:section:load/unload rearman dock y observadores. */
(function () {
  'use strict';
  if (window.__alpHomeV2) return;
  window.__alpHomeV2 = true;

  var reduce = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  /* true si el clic cayó en el ::backdrop (fuera de la caja del dialog) */
  var outside = function (event) {
    var r = event.target.getBoundingClientRect();
    return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
  };
  var home = function () { return document.querySelector('[data-alp-home]'); };

  /* ---------- Pasos del decant y video (G1, G2) ---------- */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var step = t.closest('[data-alp-step]');
    if (step) {
      var root = step.closest('[data-alp-home]');
      if (!root) return;
      root.querySelectorAll('[data-alp-step]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === step)); });
      var shown = null;
      root.querySelectorAll('[data-alp-panel]').forEach(function (p) {
        p.hidden = p.dataset.alpPanel !== step.dataset.alpStep;
        if (!p.hidden) shown = p;
      });
      if (shown) {
        var r = shown.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) shown.scrollIntoView({ block: 'nearest', behavior: reduce() ? 'auto' : 'smooth' });
      }
      return;
    }
    var open = t.closest('[data-alp-video-open]');
    if (open) {
      var dialog = open.closest('[data-alp-home]').querySelector('.alp-video-dialog');
      if (!dialog) return;
      var video = dialog.querySelector('video');
      if (video && video.dataset.src && !video.getAttribute('src')) video.src = video.dataset.src;
      if (video && video.dataset.poster && !video.getAttribute('poster')) video.poster = video.dataset.poster;
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      if (video) { var pl = video.play(); if (pl && pl.catch) pl.catch(function () {}); }
      return;
    }
    var close = t.closest('[data-alp-video-close]');
    var backdrop = t.matches && t.matches('.alp-video-dialog') && outside(event);
    if (close || backdrop) {
      var dlg = close ? close.closest('dialog') : t;
      var v = dlg.querySelector('video');
      if (v) v.pause();
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    }
  });
  document.addEventListener('close', function (event) {
    if (event.target.matches && event.target.matches('.alp-video-dialog')) {
      var v = event.target.querySelector('video');
      if (v) v.pause();
    }
  }, true);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) document.querySelectorAll('[data-alp-home] video').forEach(function (v) { v.pause(); });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var btn = event.target.querySelector && event.target.querySelector('[data-alp-step]');
    if (btn) btn.click();
  });

  /* ---------- Carrusel de escritorio (sin .at(-1) para iOS < 15.4) ---------- */
  var carousels = new WeakMap();
  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-alp-carousel]').forEach(function (root) {
      if (carousels.has(root)) return;
      var track = root.querySelector('[data-alp-carousel-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-alp-product]'));
      var prev = root.querySelector('[data-alp-carousel-prev]');
      var next = root.querySelector('[data-alp-carousel-next]');
      var position = root.querySelector('[data-alp-carousel-position]');
      var controls = root.querySelector('[data-alp-carousel-controls]');
      var progress = root.querySelector('[data-alp-carousel-progress]');
      if (!cards.length || !prev || !next) return;
      var desktopOnly = root.hasAttribute('data-alp-carousel-desktop');
      var desktopMedia = desktopOnly ? window.matchMedia('(min-width: 1101px)') : null;
      var enabled = function () { return !desktopMedia || desktopMedia.matches; };
      var wasEnabled = enabled();
      var lastFocused = root.contains(document.activeElement) ? document.activeElement : null;
      var positionTimer = 0;
      var frame = 0;
      function rememberFocus(event) {
        lastFocused = root.contains(event.target) ? event.target : null;
      }
      function forgetFocus(event) {
        /* CSS puede ocultar el foco antes de que llegue el evento de cambio del media query. */
        if ((event.relatedTarget && !root.contains(event.relatedTarget)) || (!event.relatedTarget && enabled())) lastFocused = null;
      }
      function recoverHiddenFocus() {
        var active = document.activeElement;
        var focused = root.contains(active) ? active : ((!active || active === document.body) ? lastFocused : null);
        if (!focused) return;
        var extra = focused.closest && focused.closest('.alp-product--extra');
        var willHide = (controls && controls.contains(focused)) || (extra && track.contains(extra));
        var heading = willHide && root.querySelector('.alp-heading');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      }
      function update() {
        frame = 0;
        var active = enabled();
        if (wasEnabled && !active) recoverHiddenFocus();
        wasEnabled = active;
        window.clearTimeout(positionTimer);
        positionTimer = 0;
        if (!active) {
          track.removeAttribute('tabindex');
          root.removeAttribute('aria-roledescription');
          if (controls) controls.hidden = true;
          if (progress) progress.hidden = true;
          prev.disabled = true;
          next.disabled = true;
          if (track.scrollLeft) track.scrollTo({ left: 0, behavior: 'auto' });
          return;
        }
        track.setAttribute('tabindex', '0');
        root.setAttribute('aria-roledescription', 'carrusel');
        var bounds = track.getBoundingClientRect();
        var visible = [];
        cards.forEach(function (card, i) {
          var rect = card.getBoundingClientRect();
          var visibleWidth = Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left);
          if (rect.width > 0 && visibleWidth >= rect.width / 2) visible.push(i);
        });
        var first = visible.length ? visible[0] : 0;
        var last = visible.length ? visible[visible.length - 1] : first;
        var text = (first + 1) + '–' + (last + 1) + ' de ' + cards.length;
        if (position && position.textContent !== text) {
          if (!position.textContent) position.textContent = text;
          else positionTimer = window.setTimeout(function () {
            positionTimer = 0;
            position.textContent = text;
          }, 170);
        }
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        var overflow = track.scrollWidth > track.clientWidth + 2;
        if (controls) controls.hidden = !overflow;
        if (progress && progress.firstElementChild) {
          progress.hidden = !overflow;
          progress.firstElementChild.style.width = Math.min(100, track.clientWidth / track.scrollWidth * 100) + '%';
          progress.firstElementChild.style.marginLeft = track.scrollLeft / track.scrollWidth * 100 + '%';
        }
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(update); }
      function move(direction) {
        if (!enabled()) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var stride = cards[0].getBoundingClientRect().width + gap;
        if (!stride) return;
        var page = Math.max(1, Math.floor((track.clientWidth + gap + 2) / stride));
        var target = (Math.round(track.scrollLeft / stride) + direction * page) * stride;
        track.scrollTo({ left: target, behavior: reduce() ? 'auto' : 'smooth' });
      }
      var back = function () { move(-1); };
      var forward = function () { move(1); };
      function keyboard(event) {
        if (!enabled() || event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'auto' });
        }
      }
      function revealFocus(event) {
        if (!enabled() || !event.target.closest) return;
        var card = event.target.closest('[data-alp-product]');
        if (!card || !track.contains(card)) return;
        var bounds = track.getBoundingClientRect();
        var rect = card.getBoundingClientRect();
        var offset = rect.left < bounds.left ? rect.left - bounds.left : (rect.right > bounds.right ? rect.right - bounds.right : 0);
        /* Mueve sólo el eje horizontal: el foco conserva la posición vertical de la página. */
        if (Math.abs(offset) > 1) track.scrollTo({ left: track.scrollLeft + offset, behavior: 'auto' });
      }
      prev.addEventListener('click', back);
      next.addEventListener('click', forward);
      track.addEventListener('scroll', schedule, { passive: true });
      track.addEventListener('keydown', keyboard);
      track.addEventListener('focusin', revealFocus);
      if (desktopOnly) {
        document.addEventListener('focusin', rememberFocus);
        root.addEventListener('focusout', forgetFocus);
      }
      if (desktopMedia) {
        if (desktopMedia.addEventListener) desktopMedia.addEventListener('change', schedule);
        else if (desktopMedia.addListener) desktopMedia.addListener(schedule);
      }
      var resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
      if (resize) resize.observe(track); else window.addEventListener('resize', schedule);
      carousels.set(root, function () {
        if (resize) resize.disconnect(); else window.removeEventListener('resize', schedule);
        cancelAnimationFrame(frame);
        window.clearTimeout(positionTimer);
        prev.removeEventListener('click', back); next.removeEventListener('click', forward);
        track.removeEventListener('scroll', schedule); track.removeEventListener('keydown', keyboard);
        track.removeEventListener('focusin', revealFocus);
        if (desktopOnly) {
          document.removeEventListener('focusin', rememberFocus);
          root.removeEventListener('focusout', forgetFocus);
        }
        if (desktopMedia) {
          if (desktopMedia.removeEventListener) desktopMedia.removeEventListener('change', schedule);
          else if (desktopMedia.removeListener) desktopMedia.removeListener(schedule);
        }
        carousels.delete(root);
      });
      update();
    });
  }

  /* ---------- Hoja de tamaños (D4), dock (L1), carrito y dataLayer ---------- */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var mqMobile = window.matchMedia('(max-width: 760px)');
  var fmt = null;
  try { fmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0, maximumFractionDigits: 0 }); } catch (e) { fmt = null; }
  var money = function (cents) {
    var n = Math.round(cents) / 100;
    return fmt ? fmt.format(n) : '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  /* Contador del header de Flex (header-classic): <span class="header-cart__count … badge" data-bind="itemCount"> */
  var HEADER_COUNT_SELECTOR = '.header-cart__count';
  var sheetEl = function () { return document.querySelector('[data-alp-sheet]'); };
  var threshold = function () { var h = home(); return h ? Number(h.dataset.alpThreshold) || 0 : 0; };
  /* O5: Shopify calcula la tarifa gratis con el total YA con descuentos; con cupón puede no aplicar */
  var SHIP_DONE = '¡Listo! Envío gratis (con cupón cuenta el total final)';
  var shipText = function (total) {
    var thr = threshold();
    if (!thr) return '';
    var left = Math.max(0, thr - total);
    return left > 0 ? 'Te faltan ' + money(left) + ' para envío gratis' : SHIP_DONE;
  };
  var track = function (event, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, data || {})); } catch (e) { /* sin analítica */ }
  };
  /* F-05: con el dialog modal abierto todo lo de fuera es inerte para lectores de pantalla; se anuncia dentro */
  var announce = function (msg) {
    var dlg = document.querySelector('[data-alp-sheet]');
    var el = dlg && dlg.open ? dlg.querySelector('[data-alp-sheet-live]') : null;
    el = el || document.querySelector('[data-alp-live]');
    if (!el) return;
    el.textContent = '';
    var version = sheetVersion;
    window.clearTimeout(announceTimer);
    announceTimer = window.setTimeout(function () { if (version === sheetVersion) el.textContent = msg; }, 60);
  };
  var lastAnnounce = '';
  var cartReadEpoch = 0;
  var cartReadFlight = null;
  var lastCartReadStart = -1;
  var cartClock = function () { return window.performance && typeof window.performance.now === 'function' ? window.performance.now() : Date.now(); };
  var invalidateCart = function () { cartReadEpoch += 1; };
  var cartReadCovers = function (end) {
    return end > 0 && window.performance && typeof window.performance.now === 'function' &&
      (lastCartReadStart >= end || (cartReadFlight && cartReadFlight.started >= end));
  };
  var getCart = function () {
    if (cartReadFlight) return cartReadFlight.promise;
    var flight = { epoch: cartReadEpoch, started: cartClock(), promise: null };
    cartReadFlight = flight;
    flight.promise = fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    }).then(function (next) {
      cartReadFlight = null;
      /* Una mutación posterior invalida esta lectura; todos los consumidores esperan la siguiente. */
      if (flight.epoch !== cartReadEpoch) return getCart();
      lastCartReadStart = flight.started;
      return next;
    }, function (error) {
      cartReadFlight = null;
      if (flight.epoch !== cartReadEpoch) return getCart();
      throw error;
    });
    return flight.promise;
  };

  var cart = { item_count: 0, total_price: 0 };
  var cartKnown = false;
  /* R8: estado inicial del carrito desde Liquid (data-alp-cart-*), sin petición al cargar */
  function seedCart(h) {
    if (cartKnown || !h) return;
    cart = { item_count: Number(h.dataset.alpCartCount) || 0, total_price: Number(h.dataset.alpCartTotal) || 0 };
  }
  var current = null;
  var lastTrigger = null;
  var sheetVersion = 0;
  var sheetClosing = false;
  var closeTimer = 0;
  var autoCloseTimer = 0;
  var closeAnnounceTimer = 0;
  var announceTimer = 0;
  var dock = null;
  var observers = [];
  var reviewsTimer = 0;
  var reviewsToken = null;
  var state = { pastHero: false, pastStart: false, hasStart: false, nearClosing: false, atEnd: false, typing: false, menu: false, nearDecantCta: false };

  function clearSheetTimers() {
    [closeTimer, autoCloseTimer, closeAnnounceTimer, announceTimer].forEach(function (timer) { window.clearTimeout(timer); });
    closeTimer = autoCloseTimer = closeAnnounceTimer = announceTimer = 0;
  }

  function activeSheet(version, dialog) {
    return version === sheetVersion && dialog === sheetEl() && dialog.open && !sheetClosing;
  }

  /* R7: refresca el mini-cart de Flex; si todavía no existe, actualiza el contador del header */
  function syncThemeCart(next) {
    var ajaxCart = window.PXUTheme && window.PXUTheme.jsAjaxCart;
    if (ajaxCart && typeof ajaxCart.updateView === 'function') {
      try { ajaxCart.updateView(); return; } catch (e) { /* respaldo abajo */ }
    }
    document.querySelectorAll(HEADER_COUNT_SELECTOR).forEach(function (el) { el.textContent = String(next.item_count); });
    document.querySelectorAll('[data-ajax-cart-trigger]').forEach(function (el) { el.classList.toggle('has-cart-count', next.item_count > 0); });
  }

  function setCart(next, added) {
    cart = { item_count: Number(next.item_count) || 0, total_price: Number(next.total_price) || 0 };
    cartKnown = true;
    paintDock(added);
    /* F-02: si la hoja está abierta (formulario), sus textos de envío y etiquetas usan el total nuevo */
    var dlg = sheetEl();
    if (!added && dlg && dlg.open && current && !dlg.querySelector('[data-alp-sheet-form]').hidden) {
      var sel = dlg.querySelector('[data-alp-sheet-chips] input:checked');
      var selV = null;
      (current.v || []).forEach(function (x) { if (sel && String(x.id) === sel.value) selV = x; });
      var hadFocus = !!document.activeElement && document.activeElement.matches('[data-alp-sheet-chips] input');
      buildChips(current.v || [], selV);
      priceLabel(selV);
      shipHint();
      if (hadFocus) {
        var again = dlg.querySelector('[data-alp-sheet-chips] input:checked') || dlg.querySelector('[data-alp-sheet-add]');
        if (again) again.focus({ preventScroll: true });
      }
    }
    document.dispatchEvent(new CustomEvent('alp:cart', { detail: { cart: next, added: added } }));
  }

  function priceLabel(v) {
    var dlg = sheetEl();
    if (!dlg) return;
    dlg.querySelector('[data-alp-sheet-add-price]').textContent = v ? ' · ' + money(v.p) : '';
    var button = dlg.querySelector('[data-alp-sheet-add]');
    button.disabled = !v || !v.a || button.dataset.state === 'loading' || button.dataset.state === 'done';
    dlg.querySelectorAll('.alp-chip').forEach(function (chip) {
      var input = chip.querySelector('input');
      chip.classList.toggle('is-checked', !!(input && input.checked));
    });
  }

  function shipHint() {
    var dlg = sheetEl();
    var thr = threshold();
    if (!dlg || !thr) return;
    /* En la hoja la aclaración del cupón va en la nota fina de abajo; el renglón queda corto */
    var ship = cart.total_price > 0 ? shipText(cart.total_price) : 'Envío gratis desde ' + money(thr);
    dlg.querySelector('[data-alp-sheet-ship]').textContent = ship === SHIP_DONE ? '¡Listo! Tu pedido alcanza el envío gratis' : ship;
    var fine = dlg.querySelector('[data-alp-sheet-fine]');
    if (fine) fine.hidden = !(cart.total_price >= thr || dlg.querySelector('.alp-chip__tag'));
  }

  function buildChips(variants, def) {
    var dlg = sheetEl();
    var grid = dlg.querySelector('[data-alp-sheet-chips]');
    var fieldset = dlg.querySelector('[data-alp-sheet-fieldset]');
    var thr = threshold();
    var base = cart.total_price;
    grid.textContent = '';
    fieldset.classList.toggle('alp-chips--wide', variants.some(function (v) { return String(v.t).length > 6; }));
    variants.forEach(function (v) {
      var label = document.createElement('label');
      label.className = 'alp-chip' + (v.a ? '' : ' is-disabled');
      var input = document.createElement('input');
      input.type = 'radio'; input.name = 'id'; input.value = String(v.id);
      input.checked = !!def && def.id === v.id;
      input.disabled = !v.a;
      var size = document.createElement('span'); size.className = 'alp-chip__size'; size.textContent = v.t === 'Default Title' ? 'Único' : (/^\d+( × \d+)? ml$/.test(v.t) ? v.t.replace(/ /g, ' ') : v.t);
      var price = document.createElement('span'); price.className = 'alp-chip__price'; price.textContent = money(v.p);
      label.appendChild(input); label.appendChild(size); label.appendChild(price);
      if (thr && v.a && base < thr && base + v.p >= thr) {
        var tag = document.createElement('span'); tag.className = 'alp-chip__tag'; tag.textContent = 'Llegas a envío gratis';
        label.appendChild(tag);
      }
      grid.appendChild(label);
    });
    fieldset.hidden = variants.length < 2;
  }

  function openSheet(data, trigger) {
    var dlg = sheetEl();
    if (!dlg || typeof dlg.showModal !== 'function') return false;
    var variants = Array.isArray(data.v) ? data.v : [];
    if (!variants.length) return false;
    clearSheetTimers();
    sheetVersion += 1;
    sheetClosing = false;
    current = data; lastTrigger = trigger;
    seedCart(home());
    var def = null;
    variants.forEach(function (v) { if (!def && v.a && v.k === data.d) def = v; });
    variants.forEach(function (v) { if (!def && v.a) def = v; });
    var img = dlg.querySelector('[data-alp-sheet-img]');
    if (data.i) { img.src = data.i; img.hidden = false; } else { img.hidden = true; }
    dlg.querySelector('[data-alp-sheet-brand]').textContent = data.b || '';
    dlg.querySelector('[data-alp-sheet-name]').textContent = data.n || '';
    var rating = dlg.querySelector('[data-alp-sheet-rating]');
    rating.hidden = !(data.r && data.c);
    rating.textContent = data.r && data.c ? '★ ' + data.r + ' · ' + data.c + ' reseñas' : '';
    var pdp = dlg.querySelector('[data-alp-sheet-pdp]');
    pdp.href = data.u;
    /* R-11: en un discovery set lo que importa es qué perfumes trae */
    var pdpLabel = pdp.querySelector('[data-alp-sheet-pdp-label]');
    if (pdpLabel) pdpLabel.textContent = data.s ? 'Ver qué perfumes incluye' : 'Ver notas y todos los tamaños';
    var btn = dlg.querySelector('[data-alp-sheet-add]');
    btn.dataset.state = '';
    btn.removeAttribute('aria-busy');
    buildChips(variants, def);
    priceLabel(def);
    shipHint();
    dlg.querySelector('[data-alp-sheet-add-label]').textContent = 'Agregar';
    dlg.querySelector('[data-alp-sheet-msg]').textContent = '';
    var sheetLive = dlg.querySelector('[data-alp-sheet-live]');
    if (sheetLive) sheetLive.textContent = '';
    lastAnnounce = '';
    dlg.querySelector('[data-alp-sheet-done]').hidden = true;
    dlg.querySelector('[data-alp-sheet-form]').hidden = false;
    pdp.hidden = false;
    dlg.showModal();
    document.documentElement.classList.add('alp-sheet-open');
    void dlg.offsetHeight;
    dlg.classList.add('is-open');
    var checked = dlg.querySelector('[data-alp-sheet-chips] input:checked');
    (checked || btn).focus({ preventScroll: true });
    renderDock();
    track('alp_quick_open', { alp_product_url: data.u });
    return true;
  }

  function closeSheet() {
    var dlg = sheetEl();
    if (!dlg || !dlg.open) return;
    clearSheetTimers();
    sheetClosing = true;
    var version = ++sheetVersion;
    dlg.classList.remove('is-open');
    var done = function () { if (version === sheetVersion && dlg.open) dlg.close(); };
    if (reduce()) done(); else closeTimer = window.setTimeout(done, 200);
  }

  document.addEventListener('close', function (event) {
    if (!(event.target.matches && event.target.matches('[data-alp-sheet]'))) return;
    if (event.target.open) return;
    clearSheetTimers();
    sheetVersion += 1;
    sheetClosing = false;
    event.target.classList.remove('is-open');
    document.documentElement.classList.remove('alp-sheet-open');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
    /* F-05: en móvil la hoja se cierra sola tras agregar; el aviso se repite fuera, ya sin el modal */
    if (lastAnnounce) {
      var msgOut = lastAnnounce;
      var version = sheetVersion;
      lastAnnounce = '';
      closeAnnounceTimer = window.setTimeout(function () { if (version === sheetVersion) announce(msgOut); }, 120);
    }
    renderDock();
  }, true);
  document.addEventListener('cancel', function (event) {
    if (event.target.matches && event.target.matches('[data-alp-sheet]')) { event.preventDefault(); closeSheet(); }
  }, true);

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var quick = t.closest('[data-alp-quick]');
    if (quick) {
      var card = quick.closest('[data-alp-product]');
      var json = card && card.querySelector('[data-alp-quick-data]');
      if (!json) return;
      var data = null;
      try { data = JSON.parse(json.textContent); } catch (e) { return; }
      if (openSheet(data, quick)) event.preventDefault();
      return;
    }
    if (t.closest('[data-alp-sheet-close]') || (t.matches && t.matches('[data-alp-sheet]') && outside(event))) { closeSheet(); return; }
    var copy = t.closest('[data-alp-copy]');
    if (copy) {
      var code = copy.getAttribute('data-alp-copy');
      var ok = function () { copy.textContent = 'Copiado'; window.setTimeout(function () { copy.textContent = 'Copiar código'; }, 2000); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, function () {});
      track('alp_coupon_copy', { alp_code: code });
      return;
    }
    var wa = t.closest('[data-alp-wa]');
    if (wa) track('alp_whatsapp_click', { alp_location: wa.dataset.alpWa });
    var cta = t.closest('[data-alp-dock-cta]');
    if (cta) track('alp_dock_click', { alp_state: cta.dataset.alpDockCta });
    if (t.closest('[data-alp-hero-all]')) track('alp_hero_all_click', {});
  });

  document.addEventListener('keydown', function (event) {
    if ((event.key === ' ' || event.key === 'Spacebar') && event.target.matches && event.target.matches('[data-alp-quick]')) {
      event.preventDefault();
      event.target.click();
    }
  });

  /* R-02: Tab y Shift+Tab no salen de la hoja (showModal deja escapar el foco a la barra del navegador).
     Un grupo de radios es una sola parada de Tab: la marcada o, si no hay, la primera habilitada. */
  function sheetFocusables(dlg) {
    var list = Array.prototype.slice.call(dlg.querySelectorAll('[data-alp-sheet-close], [data-alp-sheet-chips] input[name="id"], [data-alp-sheet-add], [data-alp-sheet-pdp], [data-alp-sheet-done] a[href], [data-alp-sheet-done] button'));
    var checked = dlg.querySelector('[data-alp-sheet-chips] input[name="id"]:checked:not(:disabled)');
    var radioSeen = false;
    return list.filter(function (el) {
      if (el.disabled || el.closest('[hidden]')) return false;
      if (el.type === 'radio') {
        if (checked ? el !== checked : radioSeen) return false;
        radioSeen = true;
        return true;
      }
      return el.getClientRects().length > 0;
    });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
    var dlg = sheetEl();
    if (!dlg || !dlg.open) return;
    var items = sheetFocusables(dlg);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    var inside = !!active && dlg.contains(active);
    /* Cualquier radio del grupo cuenta como la parada del grupo */
    var atFirst = active === first || (first.type === 'radio' && active && active.type === 'radio' && inside);
    var atLast = active === last || (last.type === 'radio' && active && active.type === 'radio' && inside);
    if (event.shiftKey) {
      if (!inside || atFirst) { event.preventDefault(); last.focus(); }
    } else if (!inside || atLast) {
      event.preventDefault(); first.focus();
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-alp-sheet] input[name="id"]');
    if (!input || !current) return;
    var v = null;
    (current.v || []).forEach(function (x) { if (String(x.id) === input.value) v = x; });
    priceLabel(v);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-alp-sheet-form]');
    if (!form || !current) return;
    event.preventDefault();
    var dlg = sheetEl();
    var btn = form.querySelector('[data-alp-sheet-add]');
    var label = form.querySelector('[data-alp-sheet-add-label]');
    var msg = form.querySelector('[data-alp-sheet-msg]');
    var checked = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]:not(:disabled)');
    var id = checked ? Number(checked.value) : 0;
    if (!id || !dlg || !dlg.open || sheetClosing || btn.dataset.state === 'loading' || btn.dataset.state === 'done') return;
    var v = null;
    (current.v || []).forEach(function (x) { if (x.id === id) v = x; });
    var product = current;
    var version = sheetVersion;
    invalidateCart();
    btn.dataset.state = 'loading';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    label.textContent = 'Agregando…';
    msg.textContent = '';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var userMsg = res.status >= 400 && res.status < 500 && typeof data.description === 'string' && data.description ? data.description : '';
          throw { alpUser: userMsg };
        }
        /* Ya está en el carrito: si /cart.js falla, se estima el carrito y se relee después (no se invita a un segundo agregado) */
        invalidateCart();
        return getCart().catch(function () {
          window.setTimeout(refreshCart, 1500);
          return { item_count: cart.item_count + 1, total_price: cart.total_price + (v ? v.p : 0), alpEstimated: true };
        });
      });
    }).then(function (next) {
      var added = product.n + (v && v.t !== 'Default Title' ? ' · ' + v.t : '');
      var thr = threshold();
      var ship = thr ? shipText(next.total_price) + '.' : '';
      var value = v ? v.p / 100 : 0;
      try { (window.dataLayer = window.dataLayer || []).push({ ecommerce: null }); } catch (e) { /* sin analítica */ }
      track('alp_quick_add', {
        alp_variant_id: id,
        alp_value: value,
        alp_currency: 'MXN',
        ecommerce: {
          currency: 'MXN',
          value: value,
          /* R-15: mismo id que Google Merchant Center (shopify_MX_<producto>_<variante>) y nombre con la marca */
          items: [{ item_id: product.pid ? 'shopify_MX_' + product.pid + '_' + id : String(id), item_name: (product.b ? product.b + ' ' : '') + product.n, item_brand: product.b || undefined, item_variant: v ? v.t : undefined, price: value, quantity: 1 }]
        }
      });
      setCart(next, activeSheet(version, dlg) ? added : undefined);
      syncThemeCart(next);
      if (!activeSheet(version, dlg)) return;
      btn.dataset.state = 'done';
      btn.disabled = true;
      label.textContent = 'Agregado';
      lastAnnounce = added + ' agregado al carrito. ' + ship;
      announce(lastAnnounce);
      /* QA r3 #3: la hoja solo se cierra sola si el dock de carrito va a confirmar el agregado (ya pasó el hero).
         Desde la primera pantalla se queda abierta con "Agregado a tu carrito" y el contador del header. */
      if (dock && mqMobile.matches && state.pastHero) {
        /* F-05: margen para que el lector anuncie dentro de la hoja; el evento 'close' lo repite fuera */
        autoCloseTimer = window.setTimeout(function () { if (activeSheet(version, dlg)) closeSheet(); }, reduce() ? 500 : 700);
      } else {
        lastAnnounce = '';
        form.hidden = true;
        dlg.querySelector('[data-alp-sheet-pdp]').hidden = true;
        dlg.querySelector('[data-alp-sheet-ship]').textContent = '';
        var fineDone = dlg.querySelector('[data-alp-sheet-fine]');
        if (fineDone) fineDone.hidden = true;
        var done = dlg.querySelector('[data-alp-sheet-done]');
        done.hidden = false;
        done.querySelector('[data-alp-sheet-done-line]').textContent = added + '. ' + ship;
        var bar = done.querySelector('[data-alp-sheet-bar]');
        bar.style.transform = 'scaleX(' + (thr ? Math.min(1, next.total_price / thr) : 1) + ')';
        var primary = done.querySelector('a');
        if (primary) primary.focus({ preventScroll: true });
      }
    }).catch(function (err) {
      if (!activeSheet(version, dlg)) return;
      btn.dataset.state = '';
      btn.disabled = false;
      label.textContent = 'Agregar';
      msg.textContent = (err && err.alpUser) || 'No pudimos agregarlo. Intenta de nuevo.';
    }).then(function () {
      if (activeSheet(version, dlg)) btn.removeAttribute('aria-busy');
    });
  });

  /* ----- Dock inferior ----- */
  function renderDock() {
    if (!dock) { document.documentElement.classList.remove('alp-dock-on'); return; }
    var count = cart.item_count;
    var sheetOpen = document.documentElement.classList.contains('alp-sheet-open');
    var base = mqMobile.matches && !state.typing && !state.menu && !sheetOpen && !state.atEnd;
    /* R-16: en estado "explorar" el dock no se suma al botón del decant, que lleva al mismo lugar */
    var browseReady = (state.hasStart ? state.pastStart : state.pastHero) && !state.nearClosing && !state.nearDecantCta;
    /* R-04/R-05 + QA r3 #3: con carrito, solo cuando el CTA del hero ya salió (no tapa los "Agregar" de la primera fila),
       ni siquiera justo después de un agregado (ahí confirman la hoja y el contador del header), y nunca sobre el cierre ni el email */
    var cartReady = state.pastHero && !state.nearClosing;
    var show = base && (count > 0 ? cartReady : browseReady);
    /* V3-VQ-06: si el dock solo se esconde por el botón del decant, la barra de anuncios no vuelve a entrar a media página */
    var keepBarHidden = base && count === 0 && state.nearDecantCta && (state.hasStart ? state.pastStart : state.pastHero) && !state.nearClosing;
    dock.classList.toggle('is-visible', show);
    dock.classList.toggle('is-cart', count > 0);
    dock.setAttribute('aria-hidden', show ? 'false' : 'true');
    if ('inert' in dock) dock.inert = !show;
    document.documentElement.classList.toggle('alp-dock-on', show || keepBarHidden);
  }

  function paintDock(added) {
    if (!dock) { renderDock(); return; }
    var thr = threshold();
    var left = Math.max(0, thr - cart.total_price);
    var countEl = dock.querySelector('[data-alp-dock-count]');
    var line = dock.querySelector('[data-alp-dock-line]');
    var bar = dock.querySelector('[data-alp-dock-bar]');
    var text = thr ? shipText(cart.total_price) : 'Subtotal ' + money(cart.total_price);
    var prev = Number(countEl.textContent) || 0;
    countEl.textContent = String(cart.item_count);
    var countSr = dock.querySelector('[data-alp-dock-count-sr]');
    if (countSr) countSr.textContent = ' (' + cart.item_count + (cart.item_count === 1 ? ' artículo)' : ' artículos)');
    window.clearTimeout(paintDock.timer);
    if (added) {
      line.textContent = '✓ ' + added + ' agregado';
      paintDock.timer = window.setTimeout(function () { line.textContent = text; }, 4000);
    } else {
      line.textContent = text;
    }
    bar.style.transform = 'scaleX(' + (thr ? Math.min(1, cart.total_price / thr) : 1) + ')';
    dock.classList.toggle('is-free', thr > 0 && left === 0);
    if (added && cart.item_count > prev && !reduce() && countEl.animate) {
      countEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 240, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }
    renderDock();
  }

  function observe(el, fn, options) {
    if (!el || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) { entries.forEach(fn); renderDock(); }, options);
    io.observe(el);
    observers.push(io);
  }

  function teardown() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
    window.clearTimeout(reviewsTimer);
    reviewsToken = null;
  }

  function initDock(h) {
    var candidate = h && h.parentElement ? h.parentElement.querySelector('[data-alp-dock]') : null;
    if (candidate) {
      document.querySelectorAll('body > [data-alp-dock]').forEach(function (n) { if (n !== candidate) n.remove(); });
      if (candidate.parentElement !== document.body) document.body.appendChild(candidate);
      dock = candidate;
    } else {
      dock = document.querySelector('body > [data-alp-dock]');
    }
    state.pastHero = false; state.pastStart = false; state.nearClosing = false; state.atEnd = false; state.nearDecantCta = false;
    if (!dock || !h) { dock = null; renderDock(); return; }
    /* F-09: .alp-actions es display:contents en móvil (IntersectionObserver nunca la ve); se observa el último botón real */
    var heroCta = h.querySelector('[data-alp-hero-end]') || h.querySelector('.alp-hero .alp-hero-all') || h.querySelector('.alp-hero .alp-hero-cta') || h.querySelector('.alp-hero');
    var start = h.querySelector('[data-alp-dock-start]');
    state.hasStart = !!start;
    /* Un solo borde por observador (rootMargin enorme hacia un lado): un scroll rápido no "salta" el cambio de estado */
    var PAST = { rootMargin: '0px 0px 100000px 0px' };
    var REACHED = { rootMargin: '100000px 0px 0px 0px' };
    observe(heroCta, function (en) { state.pastHero = !en.isIntersecting; }, PAST);
    observe(start, function (en) { state.pastStart = !en.isIntersecting; }, PAST);
    observe(h.querySelector('.alp-closing'), function (en) { state.nearClosing = en.isIntersecting; }, REACHED);
    observe(h.querySelector('[data-alp-end]'), function (en) { state.atEnd = en.isIntersecting; }, REACHED);
    observe(h.querySelector('[data-alp-decant-cta]') || h.querySelector('.alp-decant-cta'), function (en) { state.nearDecantCta = en.isIntersecting; }, { rootMargin: '0px 0px -12% 0px' });
    paintDock();
  }

  /* E1 + QA r3 #1: el hueco reservado para Judge.me (min-height del slot en móvil) se mantiene mientras carga.
     - Si pinta tarjetas (contenido >= 80 px) y deja de cambiar de alto, se quita la reserva (is-ready).
     - Si a los 6 s no hay nada: con el slot arriba del viewport se colapsa compensando el scroll (lo que se ve no se
       mueve); dentro del viewport se cambia el hueco por una tarjeta compacta (~120 px) con la calificación y
       "Leer reseñas" (el perfil público de Alambique en Judge.me); debajo del viewport el cambio se
       hace cuando el slot se acerca (aún fuera de la vista). Si en escritorio no hay reserva y el slot está a la
       vista, se espera a que salga del viewport para no empujar contenido visible.
     - Si Judge.me pinta tarde, la tarjeta se quita (también compensando si el slot ya quedó arriba). */
  var REVIEWS_WAIT = 6000;
  var REVIEWS_MIN = 80;
  var REVIEWS_FALLBACK_H = 120;
  var REVIEWS_PAGE = 'https://judge.me/reviews/stores/elalambiquemx.com';
  var REVIEWS_MODES = ['ready', 'empty', 'fallback'];

  function reviewsFallback(section) {
    var scoreEl = section.querySelector('.alp-reviews-score');
    var countEl = section.querySelector('.alp-reviews-count');
    var score = scoreEl && scoreEl.firstChild && scoreEl.firstChild.nodeType === 3 ? scoreEl.firstChild.nodeValue.trim() : '';
    var count = countEl ? countEl.textContent.split('·')[0].trim() : '';
    var box = document.createElement('div');
    box.className = 'alp-reviews-fallback';
    box.setAttribute('data-alp-reviews-fallback', '');
    if (score || count) {
      var line = document.createElement('p');
      line.className = 'alp-reviews-fallback__rating';
      /* El H2 de la sección ya lee "4.72 de 5 estrellas, 3,014 reseñas" a los lectores de pantalla */
      line.setAttribute('aria-hidden', 'true');
      var star = document.createElement('span');
      star.className = 'alp-reviews-fallback__star';
      star.textContent = '★';
      line.appendChild(star);
      line.appendChild(document.createTextNode(' ' + [score ? score + '/5' : '', count].filter(Boolean).join(' · ')));
      box.appendChild(line);
    }
    if (REVIEWS_PAGE) {
      var link = document.createElement('a');
      link.className = 'alp-reviews-fallback__link';
      var permanentLink = section.querySelector('.alp-reviews-all');
      link.href = permanentLink ? permanentLink.href : REVIEWS_PAGE;
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', 'Leer reseñas en Judge.me (se abre en otra pestaña)');
      var linkText = document.createElement('span');
      linkText.className = 'alp-reviews-fallback__text';
      linkText.textContent = 'Leer reseñas';
      link.appendChild(linkText);
      var arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      link.appendChild(arrow);
      box.appendChild(link);
    }
    return box;
  }

  function watchReviews(h) {
    var slot = h.querySelector('[data-alp-reviews-slot]');
    if (!slot) return;
    var section = slot.closest('.alp-reviews') || slot.parentElement;
    var token = reviewsToken = {};
    var done = false;
    var settled = false;
    var frame = 0;
    var waitIo = null;
    var releaseTimer = 0;
    var slotMode = '';
    var stale = slot.querySelector('[data-alp-reviews-fallback]');
    if (stale) stale.remove();
    var setMode = function (mode) {
      slotMode = mode;
      REVIEWS_MODES.forEach(function (m) {
        slot.classList.toggle('is-' + m, mode === m);
        section.classList.toggle('alp-reviews--' + m, mode === m);
      });
    };
    setMode('');
    var content = function () {
      var total = 0;
      Array.prototype.forEach.call(slot.children, function (c) {
        if (!c.hasAttribute('data-alp-reviews-fallback')) total += c.getBoundingClientRect().height;
      });
      return total;
    };
    /* Si el slot empieza arriba del viewport, el cambio de alto no debe mover lo que el visitante ve: se fija el
       borde inferior de la sección. Con scroll anchoring (Chrome/Firefox) el delta ya es 0; en Safari se compensa aquí. */
    var steady = function (change) {
      var above = slot.getBoundingClientRect().top < 0;
      var before = above ? section.getBoundingClientRect().bottom : 0;
      change();
      if (!above) return;
      var delta = section.getBoundingClientRect().bottom - before;
      if (Math.abs(delta) < 0.5) return;
      try { window.scrollTo({ top: window.scrollY + delta, left: window.scrollX, behavior: 'instant' }); } catch (e) { window.scrollTo(window.scrollX, window.scrollY + delta); }
    };
    var stopWaiting = function () { if (waitIo) { waitIo.disconnect(); waitIo = null; } };
    var finish = function () {
      releaseTimer = 0;
      if (token !== reviewsToken || slotMode === 'ready') return;
      if (slotMo) slotMo.disconnect();
      if (slotRo) slotRo.disconnect();
      steady(function () {
        var fb = slot.querySelector('[data-alp-reviews-fallback]');
        if (fb) fb.remove();
        setMode('ready');
      });
    };
    var check = function () {
      frame = 0;
      if (token !== reviewsToken || slotMode === 'ready' || content() < REVIEWS_MIN) return;
      if (!done) { done = true; window.clearTimeout(reviewsTimer); stopWaiting(); }
      /* Con la reserva puesta se espera a que Judge.me deje de cambiar de alto (500 ms) para quitarla en un solo paso;
         si ya estaba colapsado o con la tarjeta de respaldo, el cambio es inmediato */
      window.clearTimeout(releaseTimer);
      if (slotMode === '') releaseTimer = window.setTimeout(finish, 500); else finish();
    };
    var schedule = function () { if (!frame) frame = requestAnimationFrame(check); };
    var showFallback = function () {
      settled = true; stopWaiting();
      var box = reviewsFallback(section);
      if (!box.firstChild) { setMode('empty'); return; }
      slot.appendChild(box);
      setMode('fallback');
      track('alp_reviews_fallback', {});
    };
    /* Espera a que el slot entre (whenIn) o salga del viewport ampliado y vuelve a decidir */
    var waitFor = function (whenIn, options) {
      stopWaiting();
      if (!('IntersectionObserver' in window)) { showFallback(); return; }
      waitIo = new IntersectionObserver(function (entries) {
        if (entries[entries.length - 1].isIntersecting === whenIn) { stopWaiting(); settle(whenIn); }
      }, options);
      waitIo.observe(slot);
      observers.push(waitIo);
    };
    var settle = function (near) {
      if (done || settled || token !== reviewsToken) return;
      if (content() >= REVIEWS_MIN) { check(); return; }
      var r = slot.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < 0) {
        settled = true; stopWaiting();
        steady(function () { setMode('empty'); });
        return;
      }
      if (r.top >= vh && near !== true) {
        /* Debajo del viewport nadie ve el hueco: Judge.me tiene más tiempo y la tarjeta entra cuando el slot queda a
           menos de 1/4 de pantalla del borde inferior (todavía fuera de la vista, sin salto visible) */
        waitFor(true, { rootMargin: '0px 0px 25% 0px' });
        return;
      }
      if (r.top < vh && r.height < REVIEWS_FALLBACK_H) {
        /* Sin reserva y a la vista (escritorio): insertar la tarjeta empujaría contenido visible; se decide al salir */
        waitFor(false);
        return;
      }
      showFallback();
    };
    var slotRo = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
    var slotMo = 'MutationObserver' in window ? new MutationObserver(function (records) {
      if (slotRo) records.forEach(function (rec) { Array.prototype.forEach.call(rec.addedNodes, function (n) { if (n.nodeType === 1 && n.parentNode === slot) slotRo.observe(n); }); });
      schedule();
    }) : null;
    if (slotMo) { slotMo.observe(slot, { childList: true, subtree: true }); observers.push(slotMo); }
    if (slotRo) { Array.prototype.forEach.call(slot.children, function (c) { slotRo.observe(c); }); observers.push(slotRo); }
    schedule();
    reviewsTimer = window.setTimeout(settle, REVIEWS_WAIT);
  }

  /* G1 / P-01: al acercarse a la sección solo se adelanta la imagen del paso visible; las de los pasos ocultos
     (~60 KB en móvil) se piden al primer toque o foco sobre un paso, no para quien solo pasa de largo */
  function warmDecant(h) {
    var decant = h.querySelector('.alp-decant');
    if (!decant || decant.dataset.alpWarm) return;
    decant.dataset.alpWarm = '1';
    var warmHidden = function () {
      decant.querySelectorAll('[data-alp-panel][hidden] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      decant.removeEventListener('pointerdown', onIntent);
      decant.removeEventListener('focusin', onIntent);
    };
    var onIntent = function (event) { if (event.target.closest && event.target.closest('[data-alp-step]')) warmHidden(); };
    decant.addEventListener('pointerdown', onIntent, { passive: true });
    decant.addEventListener('focusin', onIntent);
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (en) { return en.isIntersecting; })) return;
      decant.querySelectorAll('[data-alp-panel]:not([hidden]) img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      io.disconnect();
    }, { rootMargin: '600px 0px' });
    io.observe(decant);
    observers.push(io);
  }

  /* FQ-03: en escritorio el botón flotante de la app Joy tapaba el H2 "Más vendidos" a 1280x800; se oculta mientras scrollY < 40 */
  var topWatched = false;
  var atTop = function () {
    document.documentElement.classList.toggle('alp-at-top', window.scrollY < 40 && !!home());
  };
  function watchTop() {
    if (!topWatched) { topWatched = true; window.addEventListener('scroll', atTop, { passive: true }); }
    atTop();
  }

  var menuWatch = function () {
    var open = !!document.querySelector('.mobile-menu--opened');
    if (open !== state.menu) { state.menu = open; renderDock(); }
  };
  var mo = new MutationObserver(menuWatch);
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('focusin', function (event) {
    var t = event.target;
    if (t.matches && t.matches('input:not([type=radio]):not([type=checkbox]):not([type=hidden]),textarea,select')) { state.typing = true; renderDock(); }
  });
  document.addEventListener('focusout', function () { if (state.typing) { state.typing = false; renderDock(); } });
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', renderDock);
  else if (mqMobile.addListener) mqMobile.addListener(renderDock);

  /* F-02: también actualiza el contador del header (antes quedaba con el número viejo al volver con Atrás) */
  var refreshCart = function (refreshNative) {
    return getCart().then(function (c) { setCart(c); if (refreshNative !== false) syncThemeCart(c); }).catch(function () {});
  };
  /* El mini-cart de Flex cambia el carrito con XHR (/cart/change.js …): se relee /cart.js para que el dock no mienta */
  var refreshTimer = 0;
  var refreshAfter = 0;
  var refreshUntimed = false;
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        if (!dock) return;
        var hit = false;
        list.getEntries().forEach(function (e) {
          if (!/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(e.name)) return;
          /* Un GET que empezó después de esta mutación ya la incluye; no se bloquean otros cambios durante 3 s. */
          var end = Number(e.responseEnd);
          if (cartReadCovers(end)) return;
          hit = true;
          refreshAfter = Math.max(refreshAfter, end || 0);
          if (!(end > 0)) refreshUntimed = true;
        });
        if (!hit) return;
        invalidateCart();
        window.clearTimeout(refreshTimer);
        /* Flex ya actualiza su mini-cart al terminar su propia mutación. */
        refreshTimer = window.setTimeout(function () {
          var covered = !refreshUntimed && cartReadCovers(refreshAfter);
          refreshAfter = 0;
          refreshUntimed = false;
          if (!covered) refreshCart(false);
        }, 150);
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* navegador sin soporte */ }
  }

  function boot(scope) {
    var h = home();
    if (!h) return;
    teardown();
    if (document.body) mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    initCarousels(scope && scope.querySelectorAll ? scope : document);
    document.querySelectorAll('[data-alp-quick]').forEach(function (a) { a.setAttribute('role', 'button'); });
    /* R8: estado inicial desde Liquid, salvo que un agregado previo (antes de boot) ya lo actualizó */
    seedCart(h);
    initDock(h);
    /* F-02: al volver con Atrás el HTML puede salir de la caché HTTP con el carrito viejo en data-alp-cart-* */
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward') refreshCart();
    } catch (e) { /* sin Navigation Timing */ }
    watchReviews(h);
    warmDecant(h);
    watchTop();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
  window.addEventListener('pageshow', function (event) { if (event.persisted && home()) refreshCart(); });
  /* F-08: al salir (p. ej. a la ficha) la hoja se cierra para que Atrás (bfcache) no la muestre con datos viejos */
  window.addEventListener('pagehide', function () {
    var d = sheetEl();
    if (d && d.open) { d.classList.remove('is-open'); lastTrigger = null; d.close(); }
  });
  document.addEventListener('alp:cart-refresh', refreshCart);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var t = event.target;
    t.querySelectorAll('[data-alp-carousel]').forEach(function (root) { var off = carousels.get(root); if (off) off(); });
    if (!t.querySelector('[data-alp-home]')) return;
    teardown();
    document.querySelectorAll('body > [data-alp-dock]').forEach(function (n) { n.remove(); });
    document.documentElement.classList.remove('alp-dock-on', 'alp-sheet-open', 'alp-at-top');
    dock = null;
  });
})();
